import { render, staticRenderFns } from "./UpdatePostPerf.vue?vue&type=template&id=6ab91dd3&scoped=true&"
import script from "./UpdatePostPerf.vue?vue&type=script&lang=js&"
export * from "./UpdatePostPerf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab91dd3",
  null
  
)

export default component.exports